module.exports = __webpack_public_path__ + "static/media/hibiki-lose.51eaa8f6.png";